var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { TableColumn } from './TableColumn';
export var TableFooter = styled.tfoot(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  top: 16px;\n  position: relative;\n\n  ", " {\n    border-top: 1px solid ", ";\n  }\n"], ["\n  top: 16px;\n  position: relative;\n\n  ", " {\n    border-top: 1px solid ", ";\n  }\n"])), TableColumn, function (props) { return props.theme.colors.border.base; });
var templateObject_1;
